import { Route } from '@angular/router';
import { HomeComponent } from '@components/home/home.component';
import { AuthPageComponent } from '@components/auth-page/auth-page.component';
import { AuthGuard } from '@services/auth-guard/authGuard';
import searchRoutes from './search.routes';
import { MixpanelEvents } from '@airwallet/shared-models/mixpanel-interfaces';

export default [
    {
        path: 'sign-up',
        component: AuthPageComponent
    },
    {
        path: 'sign-in',
        component: AuthPageComponent
    },
    {
        path: 'member/:email/:region/:key',
        loadComponent: () => import('@components/settings/members/create-member/create-member.component').then(m => m.CreateMemberComponent)
    },
    {
        path: 'member/:email/:region', // deprecated, can be removed after 1st february 2025
        loadComponent: () => import('@components/settings/members/create-member/create-member.component').then(m => m.CreateMemberComponent)
    },
    {
        path: 'set-password/:email/:operatorUid/:region/:key',
        loadComponent: () => import('../components/customers-set-password/customers-set-password.component').then(m => m.CustomersSetPasswordComponent)
    },
    {
        path: 'reset-password/:key',
        loadComponent: () => import('../components/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
    },
    {
        path: 'transactions',
        loadComponent: () => import('../components/transactions/transactions.component').then(m => m.TransactionsComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'topups',
        loadComponent: () => import('@components/topups/topups.component').then(m => m.TopupsComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'stripelink',
        loadComponent: () => import('../components/stripelink/stripelink.component').then(m => m.StripelinkComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'locations',
        loadComponent: () => import('../components/locations/locations.component').then(m => m.LocationsComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'locations/:location_id',
        loadComponent: () => import('../components/location/location.component').then(m => m.LocationComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'locations/:location_id/devices/:device_id',
        loadComponent: () => import('../components/device/device.component').then(m => m.DeviceComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'locations/:location_id/device_setup',
        loadComponent: () => import('../components/device-setup/device-setup.component').then(m => m.DeviceSetupComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'locations/:location_id/device_setup/:reconfig_values',
        loadComponent: () => import('../components/device-setup/device-setup.component').then(m => m.DeviceSetupComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'account/subscription-plan',
        loadComponent: () => import('../components/settings/subscription-plan/subscription-plan.component').then(m => m.SubscriptionPlanComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'account/subscription-plan/payment',
        loadComponent: () => import('../components/settings/subscription-plan/subscription-plan-payment/subscription-plan-payment.component').then(m => m.SubscriptionPlanPaymentComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'account',
        loadComponent: () => import('../components/settings/account/account.component').then(m => m.AccountComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'account/:param',
        loadComponent: () => import('../components/settings/account/account.component').then(m => m.AccountComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'members',
        loadComponent: () => import('@components/settings/members/members.component').then(m => m.MembersComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'coupons/coupon-create',
        loadComponent: () => import('@components/engagement/coupons/coupon-form/coupon-form.component').then(m => m.CouponFormComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'coupons/:key',
        loadComponent: () => import('@components/engagement/coupons/coupon-form/coupon-form.component').then(m => m.CouponFormComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'coupons',
        loadComponent: () => import('@components/engagement/coupons/coupons.component').then(m => m.CouponsComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'push-notifications',
        loadComponent: () => import('@components/engagement/push-notification/push-notification.component').then(m => m.PushNotificationComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'settlements',
        loadComponent: () => import('../components/settings/settlements/settlements.component').then(m => m.SettlementsComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'admin/support',
        loadComponent: () => import('@components/admin/support/support.component').then(m => m.SupportComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'admin/monitor-health',
        loadComponent: () => import('@components/health-monitor/health-monitor.component').then(m => m.HealthMonitorComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'admin/discount-tool',
        loadComponent: () => import('@components/admin/discount-tool/discount-tool.component').then(m => m.DiscountToolComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'billing',
        loadComponent: () => import('../components/settings/billing/billing.component').then(m => m.BillingComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'billing/:processing_subscription',
        loadComponent: () => import('../components/settings/billing/billing.component').then(m => m.BillingComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers',
        loadComponent: () => import('@components/operator/customers/customers.component').then(m => m.CustomersComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'contracts',
        loadComponent: () => import('../components/operator/contracts/contract-overview/contract-overview.component').then(m => m.ContractOverviewComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'devices',
        loadComponent: () => import('@components/devices/device-overview/device-overview.component').then(m => m.DeviceOverviewComponent),
        canActivate: [AuthGuard],
        data: {
            mixpanelEvent: MixpanelEvents.DEVICES
        }
    },
    {
        path: 'health-monitor',
        loadComponent: () => import('@components/health-monitor/health-monitor.component').then(m => m.HealthMonitorComponent),
        canActivate: [AuthGuard],
        data: {
            mixpanelEvent: MixpanelEvents.HEALTH_MONITOR
        }
    },
    {
        path: 'users',
        loadComponent: () => import('@components/engagement/users/users.component').then(m => m.UsersComponent),
        canActivate: [AuthGuard],
        data: {
            mixpanelEvent: MixpanelEvents.USERS
        }
    },
    {
        path: 'users/:user_id',
        loadComponent: () => import('@components/engagement/users/user/user.component').then(m => m.UserComponent),
        canActivate: [AuthGuard],
        data: {
            mixpanelEvent: MixpanelEvents.USER
        }
    },
    {
        path: 'actions',
        loadComponent: () => import('@components/actions/actions-overview/actions-overview.component').then(m => m.ActionsOverviewComponent),
        canActivate: [AuthGuard],
        data: {
            mixpanelEvent: MixpanelEvents.ACTIONS
        }
    },
    {
        path: 'developer',
        loadComponent: () => import('../components/developer/developer.component').then(m => m.DeveloperComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers/create',
        loadComponent: () => import('../components/customers-create/customers-create.component').then(m => m.CustomersCreateComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers/:sub_customer_id/locations',
        loadComponent: () => import('../components/locations/locations.component').then(m => m.LocationsComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers/:sub_customer_id/locations/:location_id',
        loadComponent: () => import('../components/location/location.component').then(m => m.LocationComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers/:sub_customer_id/locations/:location_id/devices/:device_id',
        loadComponent: () => import('../components/device/device.component').then(m => m.DeviceComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers/:sub_customer_id/locations/:location_id/device_setup',
        loadComponent: () => import('../components/device-setup/device-setup.component').then(m => m.DeviceSetupComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customers/:sub_customer_id/locations/:location_id/device_setup/:reconfig_values',
        loadComponent: () => import('../components/device-setup/device-setup.component').then(m => m.DeviceSetupComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'search',
        loadComponent: () => import('@components/search/search-page/search-page.component').then(m => m.SearchPageComponent),
        canActivate: [AuthGuard],
        loadChildren: () => searchRoutes
    },
    {
        path: '**',
        redirectTo: '/home'
    }
] satisfies Route[];
